<template>
  <v-tabs>
    <v-tab :title="'Arbeitshilfen'" active>
      <div class="modal-scrolled-content">
        <Arbeitshilfen/>
      </div>
    </v-tab>
  </v-tabs>
</template>

<script>

import Arbeitshilfen from "../Arbeitshilfen";

export default {
  components: {
    Arbeitshilfen
  }
}
</script>